import { put, select, takeLatest } from 'redux-saga/effects';
import { PersonalTask, PersonalTaskAPI } from 'api/personal-tasks';
import { logger } from 'services';
import { updateStart, update, updateSuccess, updateFailed } from '..';
import { StoreActionProps } from '../../core';
import { updatePersonalTaskSagaAction } from '../actions';
import { selectPersonalTask } from '../selectors';
import { UpdatePayload } from '../slice';

function* updatePersonalTaskSaga(action: StoreActionProps<UpdatePayload>) {
  const { payload } = action;
  const { id, data } = payload;

  const oldPersonalTask = (yield select(
    selectPersonalTask(id),
  )) as PersonalTask;

  yield put(updateStart(oldPersonalTask));

  yield put(update(payload));
  try {
    yield PersonalTaskAPI.updatePersonalTask(id, data);
    yield put(updateSuccess());
  } catch (error) {
    logger.error('updatePersonalTask failed', { error });
    yield put(update({ id, data: oldPersonalTask }));
    yield put(updateFailed());
  }
}

export function* watchUpdatePersonalTasksSaga(): Generator {
  yield takeLatest(updatePersonalTaskSagaAction.type, updatePersonalTaskSaga);
}
